import { useAppStore } from '../../stores/app';

export function Timer() {
  const timeLeft = useAppStore((s) => s.timeLeft);
  const seconds = Math.ceil(timeLeft / 1000);
  const isCritical = seconds <= 5 && seconds > 0;

  return (
    <div className={`text-center ${isCritical ? 'timer-critical' : ''}`}>
      <div className={`
        text-6xl font-bold tabular-nums
        ${isCritical ? 'text-red-500' : 'text-white'}
      `}>
        {seconds}
      </div>
      <div className="text-sm text-gray-400 mt-1">секунд</div>
    </div>
  );
}

export function TimerBar() {
  const timeLeft = useAppStore((s) => s.timeLeft);
  const gameStatus = useAppStore((s) => s.gameStatus);
  
  // Assuming 20 seconds per question
  const maxTime = 20000;
  const progress = gameStatus === 'question' ? (timeLeft / maxTime) * 100 : 0;
  const isCritical = timeLeft <= 5000 && timeLeft > 0;

  return (
    <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
      <div 
        className={`h-full transition-all duration-100 ${isCritical ? 'bg-red-500' : 'bg-primary-500'}`}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
